import { getInsiderUserObject } from "../getInsiderUserObject";

export const insiderHomePageEvent = () => {
    const bodyElement = document.body;
    const isHomePage = bodyElement?.hasAttribute('data-is-homepage');
    if (isHomePage) {
        window.InsiderQueue = [];
        window.InsiderQueue.push(getInsiderUserObject());
        window.InsiderQueue.push({
            type: 'home'
        });
        window.InsiderQueue.push({
            type: 'init'
        });
        window.Insider && window.Insider.eventManager.dispatch('init-manager:re-initialize');
    }
};
